import { createRoutine } from "../utils/routine.utils";
export var importPropertyPartnerWhise = createRoutine("PROPERTY_IMPORT_PARTNER_WHISE");
